export enum AppPaths {
	ANALYTICS = 'analytics',
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ADMINS = 'admins',

	PRODUCTS = 'products',
	PRODUCT_TYPES = 'product-types',
	PRODUCT_TYPE_VARIANTS = 'product-type-variants',
	COMPONENTS = 'components',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	CONTENTS = 'contents',
}
